module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/profile_page/prefecture-c6f233591a479be2a0c7dd632ce1c5bb.png";